<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <i class="cui-circle-check icons font-1.5xl"></i> Balanza de
            Comprobacion
            <i @click="visible = !visible" style="cursor: pointer;" :class="{ 'fa fa-angle-up pull-right': visible, 'fa fa-angle-down pull-right': !visible }"> </i>            
          </div>
          <b-collapse v-model="visible">
          <b-row class="cuerpo">
            <b-col cols="12" col md="2" class="pr-6">
              <label for="desde"> Mes:&nbsp; </label><br />
              <date-picker
                id="desde"
                v-model="filtros.mes"
                type="month"
                format="MM/YYYY"
                :lang="lang"
                :editable="false"
                style="width: 95%"
                :disabled="cargandoDatos"
              >
              </date-picker>
            </b-col>
            <b-col cols="12" col md="2">
              <b-form-group label="Centro">
                <b-input-group>
                  <b-form-select
                    v-model="filtros.centro_id"
                    :options="centros"
                    value-field="id"
                    text-field="nombre"
                    class="mb-3"
                    style="width:60%"
                  >
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" col md="1">
              <b-form-group label="Nivel">
                <b-input-group>
                  <b-form-select
                    v-model="filtros.nivel"
                    :options="niveles"
                    value-field="id"
                    text-field="nombre"
                    class="mb-3"
                    style="width:60%"
                  >
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" col md="2">
              <b-form-group label="Tipo">
                <b-input-group>
                  <b-form-select
                    v-model="filtros.aprobados"
                    :options="tipos"
                    value-field="id"
                    text-field="nombre"
                    class="mb-3"
                    style="width:60%"
                  >
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col col md="4">
              <button
                class="btn btn-sm btn-success text-white mr-1 mt-4"
                @click="cargarDatos('n')"
                :disabled="cargandoDatos"
              >
                <i class="fa fa-check"></i> Generar
              </button>
              <button v-show="registros.length" class="mt-4 btn btn-sm btn-success text-white" @click="cargarDatos('excel')"  :disabled="cargandoDatos">
                <i class="fa fa-file-excel-o"></i> Exportar Excel
              </button>
               <button v-show="registros.length" class="ml-1 mt-4 btn btn-sm btn-success text-white" @click="cargarDatos('pdf')"  :disabled="cargandoDatos">
                <i class="fa fa-file-pdf-o"></i> Exportar PDF
              </button>
              <b-form-checkbox v-show="mostrar_seleccion_cierre" v-model="con_cierre" name="check-button" switch>
                Incluir Cierre
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-collapse>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-show="!registros.length">
      <b-col cols="12">
        <b-card>
          <p class="cuerpo text-center" style="margin: 0;">
            {{
              yaSeRealizoPrimeraBusqueda
                ? "No hay datos disponibles."
                : "Seleccione un periodo"
            }}
          </p>
        </b-card>
      </b-col>
    </b-row>
    <section v-show="cargandoDatos">
      <b-row>
        <img
          class="mx-auto"
          src="/img/loader.svg"
          style="width:128px"
          alt="Cargando..."
        />
      </b-row>
      <b-row>
        <p class="cuerpo text-primary mx-auto">Por favor espere...</p>
      </b-row>
    </section>
    <b-row v-show="(registros.length || yaSeRealizoPrimeraBusqueda) && !cargandoDatos">
      <b-col cols="12">
        <b-card>
          
          <b-col class="cuerpodos table-responsive" style="max-height: 500px;">
            <table rules="all" style="width:101%" class="borde table-hover">
              <thead>
                <tr style="background-color:#fbfcfc">
                  <th
                    style="width:5%; vertical-align:bottom"
                    class="text-info negrita"
                  >
                    &nbsp; Cuenta:<br />
                    <input
                      class="form-control form-sm input-sm"
                      type="text"
                      v-model.trim="filtros.cuenta"
                      @change="cargarDatos()"
                      style="width:85%"
                    />
                  </th>
                  <th
                    style="width:20%; vertical-align:bottom"
                    class="text-info negrita"
                  >
                    &nbsp; Descripcion Cuenta:<br />
                    <input
                      class="form-control form-sm input-sm"
                      type="text"
                      v-model.trim="filtros.nombre"
                      @change="cargarDatos()"
                      style="width:85%"
                    />
                  </th>
                  <th
                    class="text-center text-info negrita"
                    style="width:10%;"
                  >
                    Saldo Inicial:<br />
                    <input
                      class="form-control form-sm input-sm pull-right text-right"
                      type="text"
                      v-model.trim="filtros.inicial"
                      @change="cargarDatos()"
                      style="width:85%"
                    />
                  </th>
                  <th
                    class="text-info negrita text-right text-center"
                    style="width:10%;"
                  >
                    Debe<br />
                    <span v-show="diferencia" class="text-right"
                      ><h5 class="negrita" style="color:gray">
                        {{
                          total_debe
                            | currency("", 2, { thousandsSeparator: "," })
                        }}
                      </h5></span
                    >
                    <input
                      class="form-control form-sm input-sm pull-right text-right"
                      type="text"
                      v-model.trim="filtros.debe"
                      @change="cargarDatos()"
                      style="width:85%"
                    />
                  </th>
                  <th
                    class="text-info negrita text-right text-center"
                    style="width:10%;"
                  >
                    Haber<br /><span v-show="diferencia" class="text-right"
                      ><h5 class="negrita" style="color:gray">
                        {{
                          total_haber
                            | currency("", 2, { thousandsSeparator: "," })
                        }}
                      </h5></span>

                    <input
                      class="form-control form-sm input-sm pull-right text-right"
                      type="text"
                      v-model.trim="filtros.haber"
                      @change="cargarDatos()"
                      style="width:85%"
                    />
                  </th>
                  <th
                    class="text-center negrita text-info"
                    rowspan="2"
                    style="width:10%;"
                  >
                    Saldo Final<br />
                    <input
                      class="form-control form-sm input-sm pull-right text-right"
                      type="text"
                      v-model.trim="filtros.saldo"
                      @change="cargarDatos()"
                      style="width:85%"
                    />
                  </th>
                </tr>

              </thead>
              <tbody>
                <tr
                    v-for="(r,index) in registros"
                    :key="index+r.cuenta"
                    :class="{
                      'negrita_subrayado':r.nivel ==1,
                      'negrita':r.nivel ==2,
                      'negrita_cursiva': r.nivel ==3 || r.nivel ==4,
                      'cursiva': r.nivel ==5
                    }">
                  <td v-text="r.cuenta"></td>
                  <td v-text="r.cuenta_nombre"></td>
                  <td class="text-right">
                    {{
                      r.inicial | currency("", 2, { thousandsSeparator: "," })
                    }}
                  </td>
                  <td class="text-right">
                    {{ r.debe | currency("", 2, { thousandsSeparator: "," }) }}
                  </td>
                  <td class="text-right">
                    {{ r.haber | currency("", 2, { thousandsSeparator: "," }) }}
                  </td>
                  <td class="text-right">
                    {{ r.saldo | currency("", 2, { thousandsSeparator: "," }) }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
              <tr class="negrita">
                <td colspan="3" class="text-center">TOTALES</td>
                <td class="text-right">{{ total_debe | currency("", 2, { thousandsSeparator: "," }) }}</td>
                <td class="text-right">{{ total_haber | currency("", 2, { thousandsSeparator: "," }) }}</td>
                <td></td>
              </tr>
              </tfoot>
            </table>
          </b-col>
          
          <div class="pull-right">
            <small>
              Mostrando <strong>{{ registros.length }}</strong> de
              <strong>{{ totalRows }}</strong> Registros
            </small>
          </div>
          <br />
          <b-pagination
            :hidden="totalRows < filtros.pagesize"
            class="pull-right"
            :disabled="cargandoDatos"
            v-model="filtros.currentPage"
            :total-rows="totalRows"
            :per-page="filtros.pagesize"
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import toastr from "toastr";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
import Vue2Filters from "vue2-filters";

export default {
  name: "BComprobacion",
  mixins: [Vue2Filters.mixin],
  components: { DatePicker },
  mounted() {
    this.cargarCentros();
  },
  data: () => {
    return {
      mostrar_seleccion_cierre:false,
      con_cierre:false,
      diferencia: false,
      total_debe: 0,
      total_haber: 0,
      filtros: {
        pagesize: 25000,
        currentPage: 1,
        area: undefined,
        centro_id: undefined,
        nivel: undefined,
        mes: undefined,
        reporte: "n",
        nombre: undefined,
        cuenta: undefined,
        inicial: undefined,
        debe:undefined,
        haber:undefined,
        saldo:undefined,
        aprobados:1
      },
      lang: { formatLocale: { firstDayOfWeek: 1 } },

      mes: undefined,
      cargandoDatos: false,
      registros: [],
      totalRows: 0,
      centros: [],
      niveles: [],
      tipos: [{id:1, nombre:'Comprobantes Aprobados'}, {id:2, nombre:'Incluir Comprobantes Pendientes'}],
      yaSeRealizoPrimeraBusqueda: false,
      visible:true
    };
  },
  watch: {
    "filtros.mes": {
      handler: function() {
       this.con_cierre = false;
       this.mostrar_seleccion_cierre = false;
         // eslint-disable-next-line no-undef
       let mes_repote = moment(this.filtros.mes).format("MM"); 
       if(parseInt(mes_repote) == parseInt(this.mes_cierre)) this.mostrar_seleccion_cierre = true;
      }
    }
  },
  methods: {
    suma(objeto, campo) {
      return objeto
        ? objeto.reduce((a, c) => a + (c[campo] ? parseFloat(c[campo]) : 0), 0)
        : 0;
    },
    formatoNumero(num, dec = 2) {
      return num && !isNaN(num)
        ? num.toFixed(dec).replace(/\d(?=(\d{3})+\.)/g, "$&,")
        : 0;
    },
    formatoFecha(date) {
      // eslint-disable-next-line no-undef
      return moment(date).format("YYYY-MM-DD");
    },
    async cargarCentros() {
      try {
        let model ={};
        model.empresa_id = this.empresaId;
        this.mes_cierre = '';
      // eslint-disable-next-line no-undef
      let {data:empresa} = await axios.post("/api/catalogos/empresa",{id: model.empresa_id});
      let res = empresa.data ? empresa.data : '';
      this.mes_cierre = (res && res.mes_cierre_fiscal) ? res.mes_cierre_fiscal : '';
      

        // eslint-disable-next-line no-undef
        let {data} = await axios.post("/api/catalogos/centros",{model});
        this.centros = data.data;
        this.centros.unshift({ id: undefined, nombre: "Todos" });
        this.niveles = [];
        // eslint-disable-next-line no-undef
        let niveles = await axios.post("/api/catalogos/niveles",{
          empresa_id : this.empresaId
        });

        for (let n of niveles.data) {
          this.niveles.push({ id: n, nombre: n });
        }
        this.niveles.unshift({ id: undefined, nombre: "Todos" });
      } catch (error) {
        console.log(error);
      }
    },

    async cargarDatos(reporte = "n") {

      if (!this.filtros.mes)
        return toastr["error"]("Debe Seleccionar un periodo");

      this.yaSeRealizoPrimeraBusqueda = true;
      this.filtros.reporte = reporte;
      this.filtros.empresa_id = this.empresaId;
      this.filtros.con_cierre = this.con_cierre ? 1 : 0;
      let datos =[];
      try {
        this.total_debe = 0;
        this.total_haber = 0;
        // eslint-disable-next-line no-undef
        const {data} = await axios.post(
          "/api/reportes/bcomprobaciontotales",
          this.filtros
        );
        const {totales} =data;
        this.total_debe = totales.debe;
        this.total_haber = totales.haber;

        if (reporte !== "n") {
          toastr["info"]("Generando " +reporte+" Favor Espere");
          try {
            // eslint-disable-next-line no-undef
            const response = await axios.post("/api/reportes/bcomprobacion", this.filtros,
              {
                responseType: 'arraybuffer',
              }
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
           // eslint-disable-next-line no-undef
            let mes = moment(this.filtros.mes).format("YYYY-MM"); 
            if(reporte =='excel') link.setAttribute('download', `Balanza_${this.empresaId}_${mes}.xlsx`);
            if(reporte =='pdf') link.setAttribute('download', `Balanza_${this.empresaId}_${mes}.pdf`);
            document.body.appendChild(link);
            link.click();
          } catch(error){
            console.error(error);
          }
        }
        else {
        this.cargandoDatos = true;
        this.registros = [];

          // eslint-disable-next-line no-undef
          let {data} = await axios.post("/api/reportes/bcomprobacion", this.filtros);

          let datos = data;
          this.registros = datos.data ? datos.data : [];
          this.totalRows = data && data.total ? data.total : 0;

        }
      } catch (error) {
        console.log(error);
      }
      this.cargandoDatos = false;
    }
  },
  computed: {
    ...mapGetters("authentication", ["empresaId"])
  }
};
</script>
<style scoped>
.negrita {
  font-weight: bold;
}
.negrita_subrayado {
  font-weight: bold;
  text-decoration: underline;
}
.negrita_cursiva{
  font-weight: bold;
  font-style: italic;
}
.cursiva_subrayado{
  font-style: italic;
  text-decoration: underline;
}
.cursiva{
  font-style: italic;
}

.debe_haber {
  width: 200px;
}
.table {
  margin: 0;
}
.borde {
  border: solid #dde0e2;
  border-width: 0.35px 0.35px 0.35px;
}
th {
  background: white;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}
.card-body{
  padding:0;
}
.cuerpo{
  padding:1.25rem;
}
.cuerpodos{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-bottom: 1.25rem;
}
</style>
